import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { saveMedicationAdministered } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'

export function* setMedicationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addMedicationToTimeline } = quickActionsObject
  if (addMedicationToTimeline) {
    yield put(saveMedicationAdministered())
  }
}

export function* setMedicationQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_RESPONSE], setMedicationQuickActionTimeLineRow)
}
